import { InfoFilled, InfoRegular, NoteFilled, NoteRegular, bundleIcon } from "@fluentui/react-icons";
import { StyledTab, StyledTabList } from "./HorizontalTabList.styled";
import { SelectTabData, TabValue, SelectTabEvent } from "@fluentui/react-components";

interface HorizontalTabListProps {
    selectedValue: TabValue;
    handleTabChange: (event: SelectTabEvent, data: SelectTabData) => void;
}

export const HorizontalTabList = ({selectedValue, handleTabChange}: HorizontalTabListProps) => {

    const InfoIcon = bundleIcon(InfoFilled, InfoRegular);
    const NoteIcon = bundleIcon(NoteFilled, NoteRegular);
    return (
        <StyledTabList defaultSelectedValue="details" selectedValue={selectedValue} onTabSelect={handleTabChange}>
            <StyledTab value="details" icon={<InfoIcon />}>Details</StyledTab>
            <StyledTab value="notes" icon={<NoteIcon />}>Notes</StyledTab>
        </StyledTabList>
    );
}